"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeJson = exports.deserializeError = exports.serializeJson = exports.serializeError = void 0;
const BpmnError_1 = require("./DataModels/ProcessInstance/BpmnError");
const BaseError_1 = require("./Errors/BaseError");
/**
 * @param error The error to serialize.
 * @deprecated  This function was replaced by "serializeJson".
 *
 * @returns     A string representing the serialized error.
 */
function serializeError(error) {
    return serializeJson(error);
}
exports.serializeError = serializeError;
/**
 * Serializes the given object into a JSON-string.
 *
 * @param objectToSerialize The object to serialize.
 *
 * @returns                 The given object as a JSON-string.
 */
function serializeJson(objectToSerialize) {
    if ((0, BaseError_1.isAtlasEngineError)(objectToSerialize)) {
        return objectToSerialize.serialize();
    }
    if (objectToSerialize instanceof Error || objectToSerialize instanceof BpmnError_1.BpmnError) {
        const errorJson = {
            message: objectToSerialize.message || '',
            code: objectToSerialize.code,
            name: objectToSerialize.name || '',
            stack: objectToSerialize.stack || '',
        };
        return JSON.stringify(errorJson);
    }
    return JSON.stringify(objectToSerialize);
}
exports.serializeJson = serializeJson;
/**
 * @param stringifiedError The serialized error to deserialize.
 * @deprecated             This function was replaced by "deserializeJson".
 *
 * @returns                The restored error object.
 */
function deserializeError(stringifiedError, reviverFunction) {
    return deserializeJson(stringifiedError, reviverFunction);
}
exports.deserializeError = deserializeError;
/**
 * Deserializes the given stringified object into a JSON object, if possible.
 * If the string represents an error, the result is automatically cast into a matching error type.
 * If the string does not represent an object, it is returned as it is.
 *
 * @param serializedObject The string representing the object to deserialize.
 * @param reviverFunction  Optional: A function that transforms the results.
 *                         This function is called for each member of the object.
 *                         If a member contains nested objects, the nested objects are transformed before the parent object is.
 *
 * @typedef TResult        The expected target type of the deserialized object. Defaults to any.
 *
 * @returns                The deserialized object.
 */
function deserializeJson(serializedObject, reviverFunction) {
    if (!serializedObject) {
        return serializedObject;
    }
    try {
        const result = BaseError_1.BaseError.deserialize(serializedObject, reviverFunction);
        return result;
    }
    catch (error) {
        return deserializeObject(serializedObject, reviverFunction);
    }
}
exports.deserializeJson = deserializeJson;
function deserializeObject(stringifiedError, reviverFunction) {
    const deserializedValue = tryParse(stringifiedError, reviverFunction);
    const notAnErrorOrEmpty = !deserializedValue || !deserializedValue.name || !deserializedValue.message || !deserializedValue.stack;
    if (notAnErrorOrEmpty) {
        return deserializedValue;
    }
    const error = new Error(deserializedValue.message);
    error.code = deserializedValue.code;
    error.stack = deserializedValue.stack;
    error.name = deserializedValue.name;
    return error;
}
function tryParse(value, reviverFunction) {
    try {
        const result = JSON.parse(value, reviverFunction);
        return result;
    }
    catch (error) {
        return value;
    }
}
//# sourceMappingURL=Serializer.js.map